export default __webpack_public_path__ + "static/media/dev.86040879.gif";